import { render } from "./PublicPageHeader.vue?vue&type=template&id=7ceb06f5"
import script from "./PublicPageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicPageHeader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PublicPageHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ceb06f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ceb06f5', __exports__)) {
    api.reload('7ceb06f5', __exports__)
  }
  
  module.hot.accept("./PublicPageHeader.vue?vue&type=template&id=7ceb06f5", () => {
    api.rerender('7ceb06f5', render)
  })

}


export default __exports__